import { TSelectOption } from '@/common/types/select';

export type TTreeOption<T = number | string> = TSelectOption<T> & {
  options?: TTreeOption[];
};

export type TRawTreeOption = Record<string, any>;

export type TProcessedTreeOption = TTreeOption & {
  level: number;
  hasChildren: boolean;
  children: TProcessedTreeOption[];
};

export enum LocalContextMenuActions {
  SELECT_ALL = 'select-all',
  UNSELECT_ALL = 'unselect-all',
  EXPAND_ALL = 'expand-all',
  COLLAPSE_ALL = 'collapse-all',
  SELECT_ALL_CHILDREN = 'select-all-children',
  UNSELECT_ALL_CHILDREN = 'unselect-all-children',
  SELECT_ALL_CHILDREN_BY_LEVEL = 'select-all-children-by-level',
  UNSELECT_ALL_CHILDREN_BY_LEVEL = 'unselect-all-children-by-level',
}

export enum GlobalContextMenuActions {
  SELECT_ALL = LocalContextMenuActions.SELECT_ALL,
  UNSELECT_ALL = LocalContextMenuActions.UNSELECT_ALL,
  EXPAND_ALL = LocalContextMenuActions.EXPAND_ALL,
  COLLAPSE_ALL = LocalContextMenuActions.COLLAPSE_ALL,
}

export type TAdditionalMenuConfig = {
  action: () => void;
  label: string;
};

export enum MenuModes {
  NONE = 'none',
  ACTION_ONLY = 'action-only',
  ACTION_AND_LOCAL = 'action-and-local',
  /** Глобальные и локальные действия в одном контекстном меню */
  COMBINED_MODAL = 'combined-modal',
}
